<template>
  <span
    v-if="text || slots.default"
    class="inline-flex items-center"
    :class="['v-icon', 'v-icon--' + iconPosition, {'cursor-pointer': link !== 'javascript:void(0)'}]"
    :title="text"
    @click="handleClick"
  >
    <slot name="icon">
      <i :style="iconStyle" :class="icon" class="v-icon__icon"></i>
    </slot>

    <span class="v-icon__text" v-if="text || slots.default" :style="textStyle">
      <slot>{{ text }}</slot>
    </span>
  </span>

  <span
    v-else
    class="inline-flex v-icon"
    :class="{'cursor-pointer': link !== 'javascript:void(0)'}"
    :title="text"
    @click="handleClick"
  >
    <i :style="iconStyle" :class="icon"></i>
  </span>
</template>

<script lang="ts" setup>
import { computed, toRefs, useSlots } from 'vue';

const slots = useSlots();

const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  iconPosition: {
    type: String,
    default: 'left',
  },
  iconSize: {
    type: [String, Number],
    default: 18,
  },
  color: {
    type: String,
    default: 'inherit',
  },
  text: {
    type: String,
    default: '',
  },
  textSize: {
    type: [String, Number],
    default: '14',
  },
  link: {
    type: String,
    default: 'javascript:void(0)',
  },
  target: {
    type: String,
    default: '_self',
  },
});

const emits = defineEmits(['click']);

const { icon, iconSize, color, textSize } = toRefs(props);

const iconStyle = computed(() => {
  const style: Record<string, any> = {
    width: `${iconSize.value}px`,
    height: `${iconSize.value}px`,
    fontSize: `${iconSize.value}px`,
    color: color.value,
  };

  return style;
});

const textStyle = computed(() => {
  return { color: color.value, fontSize: `${textSize.value}px` };
});

const handleClick = () => {
  if (props.link) {
    window.open(props.link, props.target);
  }

  emits('click');
};
</script>

<style lang="scss">
.v-icon {
  &--left {
    @apply flex-row items-center;
    .v-icon__icon {
      @apply mr-1;
    }
  }
  &--right {
    @apply flex-row-reverse items-center;
    .v-icon__icon {
      @apply ml-1;
    }
  }
  &--top {
    @apply flex-col items-center;
    .v-icon__icon {
      @apply mb-1;
    }
  }
  &--bottom {
    @apply flex-col-reverse items-center;
    .v-icon__icon {
      @apply mt-1;
    }
  }
}
</style>
